export enum ProjectReportStatus {
     Draft = 1,
     Submitted = 2,
     Returned = 3,
     Resubmitted = 4,
     Approved = 5,
     Rejected = 6
}